import { call, put, select, takeLatest } from 'redux-saga/effects'
import SeedOrdersActions from 'modules/domain/seedOrders/duck'
import SeedOrdersSelectors from 'modules/domain/seedOrders/selectors'
import * as managers from 'modules/domain/seedOrders/managers'
import { SeedOrderApiRecord } from 'modules/domain/seedOrders/types'
import { RequestError } from 'modules/errors'
import { updateLocationQuery } from 'modules/sagaHelpers'
import SeedOrdersRoutes from 'views/pages/SeedOrders/route'
import { ListResponse } from 'types/api'

export const fetchList = function* () {
  try {
    let currentPage = yield select(SeedOrdersSelectors.page)
    const filter = yield select(SeedOrdersSelectors.filter)
    const sorting = yield select(SeedOrdersSelectors.sorting)
    const pageSize = yield select(SeedOrdersSelectors.pageSize)

    let response: ListResponse<SeedOrderApiRecord> = yield call(managers.listSeedOrders, {
      ...filter,
      ...sorting,
      page: currentPage,
      page_size: pageSize,
    })

    const pages = Math.ceil(response.total_count / pageSize)
    if (pages !== 0 && pages < currentPage) {
      response = yield call(managers.listSeedOrders, {
        ...filter,
        ...sorting,
        page: pages,
        page_size: pageSize,
      })
      currentPage = pages
    }

    const { data, page, total_count } = response
    yield put(SeedOrdersActions.listRequestSucceed(data, total_count, page))
    yield call(updateLocationQuery, SeedOrdersRoutes.List, { page: currentPage })
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(SeedOrdersActions.listRequestFailed(errType))
  }
}

const SeedOrdersSaga = function* () {
  yield takeLatest(SeedOrdersActions.listRequested.type, fetchList)
  yield takeLatest(SeedOrdersActions.filterUpdated.type, fetchList)
  yield takeLatest(SeedOrdersActions.sortingUpdated.type, fetchList)
}

export default SeedOrdersSaga
